export default __webpack_public_path__ + "static/media/QUIET.ba5649ee.svg";